import React from 'react';
import PropTypes from 'prop-types';
import { StepConnector } from '@material-ui/core';
import { useColorLibConnectorStyles } from './styles';

const ColorlibConnector = ({ ...props }) => {
  const { failed, ...other } = props;
  const classes = useColorLibConnectorStyles();
  return (
    <StepConnector
      classes={{
        alternativeLabel: classes.alternativeLabel,
        active: failed ? classes.activeFailed : classes.active,
        completed: failed ? classes.completedFailed : classes.completed,
        line: classes.line,
        vertical: classes.vertical,
      }}
      {...other}
    />
  );
};

ColorlibConnector.propTypes = {
  failed: PropTypes.bool,
};

export default ColorlibConnector;
